export default {
  'custom.lists.title': 'Listas',
  'custom.lists.button.open': 'Abrir',
  'custom.lists.tab.groups': 'Grupos',
  'custom.lists.tab.favorites': 'Favoritos',
  'custom.lists.text.created': 'El elemento ha sido creado correctamente.',
  'custom.lists.text.removed': 'El elemento ha sido eliminado correctamente.',
  'custom.lists.text.edited': 'El elemento ha sido actualizado correctamente.',
  'custom.lists.text.listGroups': 'Grupos de Listas',
  'custom.lists.text.listEntityGroups': 'Grupos de Entidades Dinámicas',

  'custom.lists.text.type': 'Tipo',
  'custom.lists.text.cliente': 'Cliente',
  'custom.lists.text.direccion': 'Dirección',
  'custom.lists.text.distrito': 'Distrito',
  'custom.lists.text.completed': 'Completado',

  'customList.text.detail': 'Detalles',
  'customList.text.add': 'Agregar Lista',
  'customList.text.cancel': 'Cancelar',
  'customList.text.void': 'Anular',
  'customList.form.dataOrigin': 'Origen de datos',
  'customList.form.dataOrigin.process': 'Proceso',
  'customList.form.dataOrigin.dynamicEntity': 'Entidad dinámica',
  'customList.form.processId': 'Proceso',
  'customList.form.processId.related': 'Proceso relacionado (opcional)',
  'customList.form.dynamicEntityId': 'Entidad dinámica',
  'customList.text.complete': 'Completar',
  'customList.text.approve': 'Aprobar',
  'customList.text.reject': 'Rechazar',
  'customList.text.execute': 'Ejecutar',
  'customList.text.sign': 'Firmar',
  'customList.text.reassign': 'Re-Asignar',

  'custom.lists.text.message.cancel': 'El elemento ha sido cancelado correctamente',
  'custom.lists.text.message.void': 'El elemento ha sido anulado correctamente',
  'custom.lists.text.message.approve': 'El elemento ha sido aprobado correctamente',
  'custom.lists.text.message.reject': 'El elemento ha sido rechazado correctamente',
  'custom.lists.text.message.complete': 'El elemento ha sido completado correctamente',
  'custom.lists.text.message.execute': 'El elemento ha sido ejecutado correctamente',
  'custom.lists.text.message.sign': 'El elemento ha sido firmado correctamente',
  'custom.lists.text.message.reassign': 'El elemento ha sido re-asignado correctamente',

  'customList.listTaskTrace.title': 'Trazas de tareas',
  'customList.listTaskTrace.field.taskOutput': 'Salida de tarea',
  'customList.listTaskTrace.field.timeZone': 'Zona horaria',
  'customList.listTaskTrace.operationType.export': 'Exportar',
  'customList.listTaskTrace.operationType.unknown': 'Desconocido',

  // ────────────────────────────────────────────────────────────────────
  // Modern Custom Lists view (`/custom-lists/view`)
  // ────────────────────────────────────────────────────────────────────
  'custom.lists.modern.refresh': 'Actualizar',
  'custom.lists.modern.configure': 'Configurar',
  'custom.lists.modern.tagline.fallback':
    'Visualiza, filtra y opera tus elementos con acciones contextualizadas.',

  'custom.lists.modern.eyebrow.list': 'LISTA',
  'custom.lists.modern.eyebrow.cards': 'TARJETAS',
  'custom.lists.modern.eyebrow.map': 'MAPA',
  'custom.lists.modern.eyebrow.tasks': 'TAREAS',

  'custom.lists.modern.filters.toggle': 'Filtros',
  'custom.lists.modern.filters.dynamicHeader': 'Filtros de la lista',
  'custom.lists.modern.filters.clearAll': 'Limpiar todos',

  'custom.lists.modern.group.back': 'Volver a grupos',
  'custom.lists.modern.group.itemsLabel': 'elementos',

  'custom.lists.modern.empty.title': 'No hay resultados',
  'custom.lists.modern.empty.description':
    'No encontramos elementos que coincidan con los filtros actuales. Ajusta tus filtros o crea uno nuevo si tienes los permisos.',

  'custom.lists.modern.bulk.selectFirst': 'Selecciona al menos una fila para continuar.',

  'custom.lists.modern.cards.moreActions': 'Más acciones',

  'custom.lists.modern.board.untitled': 'Sin título',
  'custom.lists.modern.board.columnEmpty': 'Sin elementos',
  'custom.lists.modern.board.noColumns': 'Esta lista no tiene columnas configuradas.',
  'custom.lists.modern.board.deadlineTooltip': 'Fecha de vencimiento: {date}',
  'custom.lists.modern.board.commentsTooltip':
    '{count, plural, one {# comentario} other {# comentarios}} · Abrir comentarios',
  'global.text.unassigned': 'Sin asignar',

  // CustomList types not covered by `process-config/custom-list/locales`
  // (which only ships keys 1-4). The launchpad chip filter uses these
  // for the per-type chips on the lists view.
  'customList.select.taskBoard': 'Tablero de Tareas',
  'customList.select.cardsList': 'Tarjetas',
  'customList.select.mapList': 'Mapa',

  // Compartidos con applications-modern (declarados localmente para
  // garantizar disponibilidad cuando esta vista se carga sin Solicitudes).
  'global.text.from': 'Desde',
  'global.text.to': 'Hasta',
  'global.text.more': 'Más',
  'global.button.remove': 'Quitar',
};
